import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { apiClient } from '../../api'

const BI_STALE_TIME = 5 * 60 * 1000

export const useFeedbackSummary = () => {
  return useQuery({
    queryKey: ['analytics', 'feedback-summary'],
    queryFn: apiClient.analytics.fetchFeedbackSummary,
    staleTime: BI_STALE_TIME,
  })
}

export const useWeeklyActiveUsers = () => {
  return useQuery({
    queryKey: ['analytics', 'weekly-active-users'],
    queryFn: apiClient.analytics.fetchWeeklyActiveUsers,
    staleTime: BI_STALE_TIME,
  })
}

export const useConversationsPerDay = () => {
  return useQuery({
    queryKey: ['analytics', 'conversations-per-day'],
    queryFn: apiClient.analytics.fetchConversationsPerDay,
    staleTime: BI_STALE_TIME,
  })
}

export const useConversationsPerWeek = () => {
  return useQuery({
    queryKey: ['analytics', 'conversations-per-week'],
    queryFn: apiClient.analytics.fetchConversationsPerWeek,
    staleTime: BI_STALE_TIME,
  })
}

export const useUsersPerDay = () => {
  return useQuery({
    queryKey: ['analytics', 'users-per-day'],
    queryFn: apiClient.analytics.fetchUsersPerDay,
    staleTime: BI_STALE_TIME,
  })
}

export const useNegativeFeedback = (limit: number, offset: number, days: number) => {
  return useQuery({
    queryKey: ['analytics', 'negative-feedback', limit, offset, days],
    queryFn: () => apiClient.analytics.fetchNegativeFeedback(limit, offset, days),
    placeholderData: keepPreviousData,
    staleTime: BI_STALE_TIME,
  })
}

export const useNegativeFeedbackConversation = (messageId: string | null) => {
  return useQuery({
    queryKey: ['analytics', 'negative-feedback', messageId, 'conversation'],
    queryFn: () => apiClient.analytics.fetchNegativeFeedbackConversation(messageId as string),
    enabled: messageId !== null,
    staleTime: BI_STALE_TIME,
  })
}
